<template>
  <div class="container">
    <div class="sub-container">
      <div class="title-container">
        <h1 v-if="title != ''">
          {{title}}
        </h1>
        <div  v-else class="sceleton-title">

        </div>
      </div>
      
      <Carousel :slides="image"/>
      <button class="button" v-on:click="clicked = !clicked" >
        <svg width="28" height="24" viewBox="0 0 28 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <mask id="path-1-inside-1_663_2988" fill="white">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M2.21289 0C1.38446 0 0.712891 0.671573 0.712891 1.5C0.712891 2.32843 1.38446 3 2.21289 3H5.35913C5.58054 3 5.77559 3.14562 5.83851 3.3579L6.5478 5.75064H6.40643L8.45808 15.9883C8.56975 16.5501 8.87562 17.0548 9.32215 17.4139C9.72742 17.7399 10.2251 17.9272 10.7421 17.9508C11.0493 18.0788 11.4007 18.1059 11.7446 18.004C11.7943 17.9892 11.8426 17.9722 11.8895 17.9529H22.7707C23.3439 17.9639 23.9026 17.7731 24.3491 17.4139C24.7956 17.0548 25.1015 16.5501 25.2132 15.9883L27.1671 5.75064H9.67683L8.7148 2.50527C8.27432 1.01931 6.909 0 5.35913 0H2.21289ZM14.0299 21.6303C14.0299 22.7223 13.1439 23.6075 12.0511 23.6075C10.9582 23.6075 10.0723 22.7223 10.0723 21.6303C10.0723 20.5384 10.9582 19.6531 12.0511 19.6531C13.1439 19.6531 14.0299 20.5384 14.0299 21.6303ZM24.2758 21.6303C24.2758 22.7223 23.3899 23.6075 22.297 23.6075C21.2042 23.6075 20.3182 22.7223 20.3182 21.6303C20.3182 20.5384 21.2042 19.6531 22.297 19.6531C23.3899 19.6531 24.2758 20.5384 24.2758 21.6303Z"/>
          </mask>
          <path d="M5.83851 3.3579L7.75604 2.78948L7.75604 2.78948L5.83851 3.3579ZM6.5478 5.75064V7.75064H9.22669L8.46533 5.18223L6.5478 5.75064ZM6.40643 5.75064V3.75064H3.96587L4.44542 6.14363L6.40643 5.75064ZM8.45808 15.9883L10.4197 15.5984L10.4191 15.5954L8.45808 15.9883ZM9.32215 17.4139L10.5757 15.8555L10.5757 15.8555L9.32215 17.4139ZM10.7421 17.9508L11.5114 16.1047L11.1858 15.969L10.8334 15.9529L10.7421 17.9508ZM11.7446 18.004L12.313 19.9215L12.313 19.9215L11.7446 18.004ZM11.8895 17.9529V15.9529H11.4951L11.1302 16.1027L11.8895 17.9529ZM22.7707 17.9529L22.809 15.9533L22.7899 15.9529H22.7707V17.9529ZM24.3491 17.4139L23.0956 15.8555L23.0956 15.8555L24.3491 17.4139ZM25.2132 15.9883L27.1748 16.3783L27.1763 16.3708L27.1777 16.3633L25.2132 15.9883ZM27.1671 5.75064L29.1317 6.12559L29.5849 3.75064H27.1671V5.75064ZM9.67683 5.75064L7.75931 6.31906L8.18368 7.75064H9.67683V5.75064ZM8.7148 2.50527L6.79728 3.07369L8.7148 2.50527ZM2.71289 1.5C2.71289 1.77614 2.48903 2 2.21289 2V-2C0.279894 -2 -1.28711 -0.432997 -1.28711 1.5H2.71289ZM2.21289 1C2.48903 1 2.71289 1.22386 2.71289 1.5H-1.28711C-1.28711 3.433 0.279894 5 2.21289 5V1ZM5.35913 1H2.21289V5H5.35913V1ZM7.75604 2.78948C7.44141 1.72808 6.46619 1 5.35913 1V5C4.6949 5 4.10977 4.56315 3.92099 3.92631L7.75604 2.78948ZM8.46533 5.18223L7.75604 2.78948L3.92099 3.92631L4.63027 6.31906L8.46533 5.18223ZM6.5478 3.75064H6.40643V7.75064H6.5478V3.75064ZM4.44542 6.14363L6.49707 16.3813L10.4191 15.5954L8.36744 5.35765L4.44542 6.14363ZM6.49646 16.3783C6.69973 17.4009 7.25641 18.3191 8.06864 18.9724L10.5757 15.8555C10.4948 15.7905 10.4398 15.6994 10.4197 15.5984L6.49646 16.3783ZM8.06863 18.9724C8.80582 19.5653 9.71088 19.9058 10.6509 19.9487L10.8334 15.9529C10.7394 15.9486 10.649 15.9145 10.5757 15.8555L8.06863 18.9724ZM11.1762 16.0864C11.289 16.053 11.4096 16.0623 11.5114 16.1047L9.97287 19.797C10.6889 20.0953 11.5124 20.1588 12.313 19.9215L11.1762 16.0864ZM11.1302 16.1027C11.1456 16.0963 11.161 16.0909 11.1762 16.0864L12.313 19.9215C12.4276 19.8875 12.5396 19.848 12.6489 19.8031L11.1302 16.1027ZM11.8895 19.9529H22.7707V15.9529H11.8895V19.9529ZM22.7325 19.9525C23.7744 19.9725 24.7905 19.6256 25.6026 18.9724L23.0956 15.8555C23.0147 15.9206 22.9133 15.9553 22.809 15.9533L22.7325 19.9525ZM25.6026 18.9724C26.4149 18.3191 26.9715 17.4008 27.1748 16.3783L23.2516 15.5984C23.2315 15.6994 23.1764 15.7905 23.0956 15.8555L25.6026 18.9724ZM27.1777 16.3633L29.1317 6.12559L25.2026 5.37569L23.2486 15.6134L27.1777 16.3633ZM27.1671 3.75064H9.67683V7.75064H27.1671V3.75064ZM6.79728 3.07369L7.75931 6.31906L11.5944 5.18223L10.6323 1.93686L6.79728 3.07369ZM5.35913 2C6.02336 2 6.6085 2.43685 6.79728 3.07369L10.6323 1.93686C9.94014 -0.398225 7.79464 -2 5.35913 -2V2ZM2.21289 2H5.35913V-2H2.21289V2ZM12.0511 25.6075C14.247 25.6075 16.0299 23.8284 16.0299 21.6303H12.0299C12.0299 21.6313 12.0298 21.6301 12.0303 21.6276C12.0308 21.6251 12.0316 21.6226 12.0326 21.6203C12.0344 21.616 12.0361 21.6142 12.0367 21.6136C12.0372 21.6131 12.0389 21.6116 12.0427 21.6099C12.0448 21.6091 12.0471 21.6084 12.0492 21.6079C12.0515 21.6074 12.0523 21.6075 12.0511 21.6075V25.6075ZM8.07227 21.6303C8.07227 23.8284 9.85517 25.6075 12.0511 25.6075V21.6075C12.0498 21.6075 12.0506 21.6074 12.0529 21.6079C12.0551 21.6084 12.0573 21.6091 12.0594 21.6099C12.0633 21.6116 12.0649 21.6131 12.0655 21.6136C12.066 21.6142 12.0677 21.616 12.0696 21.6203C12.0705 21.6226 12.0713 21.6251 12.0718 21.6276C12.0723 21.6301 12.0723 21.6313 12.0723 21.6303H8.07227ZM12.0511 17.6531C9.85517 17.6531 8.07227 19.4323 8.07227 21.6303H12.0723C12.0723 21.6294 12.0723 21.6306 12.0718 21.6331C12.0713 21.6356 12.0705 21.6381 12.0696 21.6404C12.0677 21.6446 12.066 21.6465 12.0655 21.647C12.0649 21.6476 12.0633 21.6491 12.0594 21.6508C12.0573 21.6516 12.0551 21.6523 12.0529 21.6528C12.0506 21.6532 12.0498 21.6531 12.0511 21.6531V17.6531ZM16.0299 21.6303C16.0299 19.4323 14.247 17.6531 12.0511 17.6531V21.6531C12.0523 21.6531 12.0515 21.6532 12.0492 21.6528C12.0471 21.6523 12.0448 21.6516 12.0427 21.6508C12.0389 21.6491 12.0372 21.6476 12.0367 21.647C12.0361 21.6465 12.0344 21.6446 12.0326 21.6404C12.0316 21.6381 12.0308 21.6356 12.0303 21.6331C12.0298 21.6306 12.0299 21.6294 12.0299 21.6303H16.0299ZM22.297 25.6075C24.4929 25.6075 26.2758 23.8284 26.2758 21.6303H22.2758C22.2758 21.6313 22.2758 21.6301 22.2763 21.6276C22.2768 21.6251 22.2776 21.6226 22.2786 21.6203C22.2804 21.616 22.2821 21.6142 22.2826 21.6136C22.2832 21.6131 22.2848 21.6116 22.2887 21.6099C22.2908 21.6091 22.293 21.6084 22.2952 21.6079C22.2975 21.6074 22.2983 21.6075 22.297 21.6075V25.6075ZM18.3182 21.6303C18.3182 23.8284 20.1011 25.6075 22.297 25.6075V21.6075C22.2958 21.6075 22.2966 21.6074 22.2989 21.6079C22.301 21.6084 22.3033 21.6091 22.3054 21.6099C22.3092 21.6116 22.3109 21.6131 22.3114 21.6136C22.312 21.6142 22.3137 21.616 22.3155 21.6203C22.3165 21.6226 22.3173 21.6251 22.3178 21.6276C22.3183 21.6301 22.3182 21.6313 22.3182 21.6303H18.3182ZM22.297 17.6531C20.1011 17.6531 18.3182 19.4323 18.3182 21.6303H22.3182C22.3182 21.6294 22.3183 21.6306 22.3178 21.6331C22.3173 21.6356 22.3165 21.6381 22.3155 21.6404C22.3137 21.6446 22.312 21.6465 22.3114 21.647C22.3109 21.6476 22.3092 21.6491 22.3054 21.6508C22.3033 21.6516 22.301 21.6523 22.2989 21.6528C22.2966 21.6532 22.2958 21.6531 22.297 21.6531V17.6531ZM26.2758 21.6303C26.2758 19.4323 24.4929 17.6531 22.297 17.6531V21.6531C22.2983 21.6531 22.2975 21.6532 22.2952 21.6528C22.293 21.6523 22.2908 21.6516 22.2887 21.6508C22.2848 21.6491 22.2832 21.6476 22.2826 21.647C22.2821 21.6465 22.2804 21.6446 22.2786 21.6404C22.2776 21.6381 22.2768 21.6356 22.2763 21.6331C22.2758 21.6306 22.2758 21.6294 22.2758 21.6303H26.2758Z" fill="#1E70B6" mask="url(#path-1-inside-1_663_2988)"/>
        </svg>

        {{ $t('Buttons.buy') }}
      </button>
    </div>
  </div>
  

  <Modal :clicked="clicked" :getClicked="getClickedParent" :title="title"/>

</template> 

<script>
import Carousel from "@/components/Slider/Carousel.vue";
import CustomButton from "@/components/ui/CustomButton.vue";
import Modal from "@/components/ui/Modal.vue"

export default {
  name: "HeaderProduct",
  data() {
    return {
     
      clicked: false
    }
  },
  components: {CustomButton, Carousel, Modal},
  props: {
    image: {
      
    },
    title: {
      default: ''
    },
    characteristic: {
      default: ""
    },

  },
  methods: {
    scrollTo(elementID) {
      let DOMelement = document.getElementById(elementID)
      DOMelement.scrollIntoView({block: "start", behavior: "smooth"});
      // this.picked = elementID
    },

    getClickedParent(clicked) {
      this.clicked=clicked
    }
    
  },
  

}
</script>

<style scoped>


  .container {
    width: 100vw;
    display: flex;
    justify-content: center;
    padding-top: 30px;
    align-items: start;
    color: var(--text);
    background: var(--default-bg);
    /*scroll-snap-align: center;*/
  }

  .sub-container {
    width: 1000px;
    display: flex;
    flex-direction: column;
    /*align-items: center;*/
    row-gap: 20px;
    justify-content: center;
    column-gap: 30px;
  }

  @keyframes shine {
    to {
      background-position-x: -200%;
    }
  }

  .sceleton-title{
    width: 100%;
    height: 48px;

    box-sizing: border-box;

    border-radius: 12px;
    

    cursor: pointer;

    background-position: center;

    background: #eee;
    background: var(--sceleton-card);
    border-radius: 5px;
    background-size: 200% 100%;
    animation: 1.5s shine linear infinite;

    box-shadow: 1px 2px 12px rgb(0,0,0,0.3);

    overflow: hidden;

    position: relative;
  }

  .title-container{
    width: 100%;
    display: flex;
  }

  .modal{
    display: none;
  }

  .modal_flex{
    display: flex;
    overflow-y: auto;
  }

  
  
  h1 {
    font-weight: 500;
    font-size: 48px;
    /*line-height: 120%;*/
    overflow: hidden;
  }

  .button {
    width: 50%;
    height: 48px;
    border-radius: 15px;
    font-size: 20px;
    margin: 0 auto;
    color: var(--blue);
    border: solid 1px var(--blue);

    text-transform: uppercase;

    text-decoration: none;
    display: flex;
    column-gap: 30px;

    display: flex;
    justify-content: center;
    align-items: center;

    font-family: Geometria_regular;

    background: rgb(0,0,0,0);

    cursor: pointer;

    transition: 0.3s;
  }

  .button:hover {
    letter-spacing: 2px;
  }

  @media (max-width: 1300px){

    h2,h1{
      text-align: center;
      font-size: 5vh;
      width: 80%;
    }


    .title-container{
      justify-content: center;
    }
    
  }

  @media (max-width: 550px){
    .button{
      font-size: 3vh;
      width: 90%;
    }

    h2, h1{
      text-align: center;
      font-size: 4vh;
      width: 90%;
    }
  } 

  @media (max-width: 400px){
    .button{
      font-size: 2.5vh;
      width: 80%;
    }
  }

</style>